import { LOCATION_INITIALIZED } from '@angular/common';
import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';

@Injectable()
export class ConfigService {
    private _configUrl = '../../assets/config/config.json?id=' + Date.now();
    config!: IAppConfig;

    constructor(private _http: HttpClient, private _injector: Injector) {
    }

    load(): Promise<any> {
        return new Promise<any>((resolve: any) => {
            const locationInitialized = this._injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
            locationInitialized.then(() => { 
                this._http.get(this._configUrl).subscribe({
                    next: (success: any) => {
                        this.config = success as IAppConfig;
                        resolve(null);
                    },
                    error: (_error: any) => { resolve(null); }
                })
            });
        });
    }

    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return throwError(() => error.json()/* .error */ || 'Server error');
    }

    getConfig(): IAppConfig {
        return this.config;
    }
}

export interface IAppConfig {
    apiBaseURL: string;
    apiURL: string;
    logApiBaseURL: string;
    helpTextURL: string;
    jsonHeaders: Headers;
    cacheSettings: ICacheSettings;
    buildInfo: IBuildInfo;
}

export interface ICacheSettings {
    enableCache: boolean;
    expireCacheDate: string;
}

export interface IBuildInfo {
    buildName: string;
    buildNumber: string;
    buildRequestedBy: string;
    releaseName: string;
    releaseDate: string;
}